import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/client-award-type";

export const pagingClientAwardType = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getClientAwardTypeId = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdateClientAwardType = (PointRank) =>
  axios.post(API_PATH + "/save-or-update", PointRank);

export const deleteClientAwardType = (id) =>
  axios.delete(API_PATH + "/mark-delete/" + id);
